// components/Button.js
import React from 'react';
import { buttonStyle, mobileSize } from '../theme';
import useIsMobile from '../useIsMobile';

// One-line replacement for the hand-rolled "primary/save" button style objects that had drifted
// across the app (different colors, padding shapes, font-weights for the same semantic action —
// see theme.js's header comment). `disabled` gets the same dimmed-and-non-interactive treatment
// every existing saving-state button already used (opacity 0.6-0.7, cursor: default).
function Button({ variant = 'primary', size = 'md', disabled = false, style = undefined, children, ...rest }) {
  // Phase 5: on a phone every button clears the 44px touch target. Resolved here rather than at
  // the ~85 call sites, none of which change.
  const isMobile = useIsMobile();
  return (
    <button
      disabled={disabled}
      style={{
        ...buttonStyle(variant, isMobile ? mobileSize(size) : size),
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? 'default' : 'pointer',
        ...style
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
